<div class="app__container mt-10 flex flex-col gap-6">
	<!-- Back button skeleton -->
	<div class="mt-5">
		<div class="h-10 w-20 bg-gray-200 rounded animate-pulse"></div>
	</div>

	<!-- Header section skeleton -->
	<div class="flex flex-col justify-between md:flex-row md:items-center">
		<div class="h-8 w-64 bg-gray-200 rounded animate-pulse"></div>
		<div class="mt-4 md:mt-0">
			<div class="h-10 w-24 bg-gray-200 rounded animate-pulse"></div>
		</div>
	</div>

	<!-- Tabs and content section skeleton -->
	<div class="flex flex-row gap-6">
		<!-- Vertical tabs skeleton -->
		<div class="flex flex-col gap-2 min-w-48">
			@for (tab of tabs; track tab) {
				<div class="h-10 w-full bg-gray-200 rounded animate-pulse"></div>
			}
		</div>

		<!-- Content area skeleton -->
		<div class="w-full">
			<!-- User info section skeleton -->
			<div class="bg-white rounded-lg border">
				<div class="p-6">
					<div class="h-6 w-32 bg-gray-200 rounded animate-pulse mb-4"></div>
					
					<div class="bg-gray-50 p-4 rounded">
						<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
							<!-- Email field -->
							<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center">
								<div class="h-5 bg-gray-200 rounded w-16 animate-pulse mb-1 sm:mb-0"></div>
								<div class="h-5 bg-gray-200 rounded w-full sm:w-32 animate-pulse"></div>
							</div>

							<!-- Document field -->
							<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center">
								<div class="h-5 bg-gray-200 rounded w-20 animate-pulse mb-1 sm:mb-0"></div>
								<div class="h-5 bg-gray-200 rounded w-full sm:w-28 animate-pulse"></div>
							</div>

							<!-- Phone field -->
							<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center">
								<div class="h-5 bg-gray-200 rounded w-18 animate-pulse mb-1 sm:mb-0"></div>
								<div class="h-5 bg-gray-200 rounded w-full sm:w-24 animate-pulse"></div>
							</div>

							<!-- Address field -->
							<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center">
								<div class="h-5 bg-gray-200 rounded w-20 animate-pulse mb-1 sm:mb-0"></div>
								<div class="h-5 bg-gray-200 rounded w-full sm:w-40 animate-pulse"></div>
							</div>

							<!-- Birth date / Company creation field -->
							<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center">
								<div class="h-5 bg-gray-200 rounded w-28 animate-pulse mb-1 sm:mb-0"></div>
								<div class="h-5 bg-gray-200 rounded w-full sm:w-24 animate-pulse"></div>
							</div>

							<!-- Status field -->
							<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center">
								<div class="h-5 bg-gray-200 rounded w-16 animate-pulse mb-1 sm:mb-0"></div>
								<div class="h-6 w-20 bg-gray-200 rounded-full animate-pulse"></div>
							</div>
						</div>
					</div>

					<!-- Producer section skeleton -->
					<div class="mt-6">
						<div class="h-5 w-20 bg-gray-200 rounded animate-pulse mb-2"></div>
						<div class="bg-gray-50 p-3 rounded">
							<div class="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
